export default __webpack_public_path__ + "static/media/twitterDark.559c00e0.svg";